import React from "react";
import { connectHighlight } from 'react-instantsearch-dom';

const Highlight = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: '_highlightResult',
    attribute,
    hit,
  });

  return (
    <span>
      {parsedHit.map(
        (part, index) =>
          part.isHighlighted ? (
            <span key={index} className="has-text-weight-bold">{part.value}</span>
          ) : (
            <span key={index}>{part.value}</span>
          )
      )}
    </span>
  );
};

export default connectHighlight(Highlight);
